module.exports = __webpack_public_path__ + "img/ICSR_2024.3aae7f58.png";